<div>
  <div
    class="fixed lg:static top-[64px] inset-x-0 bg-gray-100 p-2 z-40 lg:pr-40 lg:pl-8 rtl:lg:pr-7 rtl:lg:pl-20 lg:top-auto animate-slide-down"
  >
    <div class="flex items-center justify-between">
      <!-- Progress -->
      <div>
        <div class="flex gap-5 items-center">
          @if (type == "completed") {
            <img src="/icons/svg/success.svg" />
          } @else {
            <i class="fas fa-times-circle text-2xl text-dc-commerce-red"></i>
          }
          <div>
            @if (type == "completed") {
              <h3 class="text-2xl font-semibold text-dc-navy">
                {{ "SUCCESS_PAGE.PAYMENT_SUCCESS" | translate }}
              </h3>
            } @else {
              <h3 class="text-2xl font-semibold text-dc-commerce-red!">
                {{ "SUCCESS_PAGE.PAYMENT_FAIL" | translate }}
              </h3>
            }
          </div>
        </div>
      </div>

      <!--Chat Button -->
      <!-- <button
        class="flex items-center gap-2 bg-white px-4 py-2 hover:bg-gray-100"
      >
        <img src="/icons/svg/chat.svg" />
        <span class="text-dc-navy font-medium hidden lg:inline">{{
          "CHAT_WITH_US" | translate
        }}</span>
      </button> -->
    </div>
  </div>

  <div class="bg-white form-bg-pattern pt-16 lg:pt-0">
    <div class="form-card">
      <!-- skeleton -->
      @if (paymentLoader) {
        <app-skeleton-loader></app-skeleton-loader>
      } @else {
        <section class="px-2">
          <div>
            <div class="text-dc-black text-sm">
              @if (type == "completed") {
                <span class="inline-block pt-2 w-full py-2"
                  >{{ "SUCCESS_PAGE.EMAIL_SENT" | translate }}
                   
                   @if (!isStandalone) {
                    <br />
                    {{ "SUCCESS_PAGE.PAYMENT_DOWNLOAD_INVOICE" | translate }}
                   }
                </span>
                <span class="inline-block w-full pt-4 py-2">{{
                  "SUCCESS_PAGE.PAYMENT_FIND_DETAIL" | translate
                }}</span>
              } @else {
                <span class="inline-block pt-2 w-full py-2">{{
                  "SUCCESS_PAGE.PAYMENT_FAILED_TRY_AGAIN" | translate
                }}</span>
              }
            </div>

            <div class="mt-5 mb-5 space-y-4">
              <table class="w-full border-t text-sm success-details-table">
                <tbody>
                  @if (!isStandalone) {
                    <tr class="border-b">
                      <td class="td_label">
                        {{ "SUCCESS_PAGE.COMPANY_NAME" | translate }}
                      </td>
                      <td class="td_value">
                        <div>
                          {{
                            lang === "ar"
                              ? memberNameArabic || memberNameEnglish
                              : memberNameEnglish || memberNameArabic
                          }}
                        </div>
                      </td>
                    </tr>
                  }
                  @if (type == "completed") {
                    <tr class="border-b">
                      <td class="td_label">
                        {{
                          "SUCCESS_PAGE.PAYMENT_REFERENCE_NUMBER" | translate
                        }}
                      </td>
                      <td class="td_value">
                        {{ spTrn }}
                      </td>
                    </tr>
                  }
                  <tr class="border-b">
                    <td class="td_label">
                      {{ "PAY.TOTAL" | translate }}
                    </td>
                    <td class="td_value">
                      <span class="currency-amount">
                        <span class="currency-icon currency-icon-aed"></span>
                        {{ displayTotalAmount | number: "1.2-2" }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- actions -->
            @if(!isStandalone) {
              <div class="flex flex-col sm:flex-row sm:flex-wrap gap-4 py-4">
                @if (type == "completed" && payments.length > 0) {
                  @if (isValidReceiptURL()) {
                    <app-button
                      class="block w-full sm:w-auto"
                      [type]="'button'"
                      [label]="'SUCCESS_PAGE.DOWNLOAD_RECEIPT' | translate"
                      classesName="btn-primary-big w-full sm:w-auto"
                      (onBtnClick)="downloadReceipt()"
                    />
                  }
                }
                <app-button
                  class="block w-full sm:w-auto"
                  [type]="'button'"
                  [label]="'BUTTONS.GO_TO_DASHBOARD' | translate"
                  classesName="card-edge-cut-white btn-primary-big w-full sm:w-auto"
                  (onBtnClick)="goToDashboard()"
                />
              </div>
            }
          </div>
        </section>

        @if (showSuggestedService) {
          <section class="lg:max-w-[80%]">
            <h1 class="section-heading">
              {{ "SUCCESS_PAGE.SUGGESTED_SERVICES" | translate }}
            </h1>

            <div class="grid gap-6 md:grid-cols-2 px-2 auto-rows-fr">
              @for (service of suggestedServices; track service) {
                <div class="h-full">
                  <div
                    class="border-blue relative card-edge-cut h-full flex flex-col"
                  >
                    <div class="card-body flex flex-col h-full">
                      <h3 class="text-lg font-semibold">
                        {{ service.serviceName | translate }}
                      </h3>

                      <div class="mt-auto pt-4">
                        <a
                          class="inline-flex items-center gap-2 font-semibold"
                          [routerLink]="['/' + service.path]"
                        >
                          {{ "SUCCESS_PAGE.START_SERVICE" | translate }}
                          <img
                            src="/icons/svg/arrow-right.svg"
                            class="rtl:rotate-180"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </section>
        }
      }
    </div>
  </div>
</div>
